export const environment = {
  production: false,
  allowNewApplications: true,
  firebase: {
    apiKey: "AIzaSyBeNXA06U3xfrk9E8gJEvu6kY7VNcD8pNk",
    authDomain: "emb-certification.firebaseapp.com",
    projectId: "emb-certification",
    storageBucket: "emb-certification.appspot.com",
    messagingSenderId: "264340741276",
    appId: "1:264340741276:web:69a5b83abc181ea3a2a159"
  },
  recaptcha: {
    siteKey: '6LdLipApAAAAAGSPFsZ_hTKCJhmXJlIdaCSxW9zn',
  },
  loginUrl: 'https://esdptest.bosenet.com/login',
  stripeKey: 'pk_test_51OsLj6RxHcwIZvoLyAoGBQ1mRrr92QVjuK7qNlaC5IIpCkXJkmeQOq49dDRPcQWpPE4RXMmzlIhXBSdXtLMwtN7d00H5xAkv6X'
};
